'use client';

import React from 'react';
import styles from './Step2RevenueNew.module.css';

interface Step2RevenueProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  translations: any;
}

export default function Step2Revenue({ value, onChange, error, translations }: Step2RevenueProps) {
  const t = translations.demoRequest?.form || translations.form || {};
  
  const revenueOptions = [
    { value: 'prefer-not-to-say', label: t.revenueOptions?.['prefer-not-to-say'] || 'Zeg ik liever niet' },
    { value: 'under-500k', label: t.revenueOptions?.['under-500k'] || '< €500k' },
    { value: '500k-1m', label: t.revenueOptions?.['500k-1m'] || '€500k - €1M' },
    { value: '1m-2m', label: t.revenueOptions?.['1m-2m'] || '€1M - €2M' },
    { value: '2m-5m', label: t.revenueOptions?.['2m-5m'] || '€2M - €5M' },
    { value: '5m-10m', label: t.revenueOptions?.['5m-10m'] || '€5M - €10M' },
    { value: 'over-10m', label: t.revenueOptions?.['over-10m'] || '> €10M' },
  ];

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t.step2?.title || 'Wat is de geschatte jaaromzet?'}</h2>
      <p className={styles.subtitle}>{t.step2?.subtitle || 'Dit helpt ons een passende oplossing voor te stellen'}</p>
      
      <div className={styles.options}>
        {revenueOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`${styles.option} ${value === option.value ? styles.active : ''} ${option.value === 'prefer-not-to-say' ? styles.preferNot : ''}`}
            onClick={() => onChange(option.value)}
          >
            <span className={styles.label}>{option.label}</span>
            <span className={styles.checkmark}>✓</span>
          </button>
        ))}
      </div>
      
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}

